/* eslint-disable indent */
import { Divider, Grid, Skeleton } from "@mui/material";
import {
  TypographyH5,
  TypographyH6,
} from "@shared-ui-components/CustomTypography";
import {
  ErrorState,
  formatNumberWithCommaAndDollar,
  formatWithPercentage,
} from "@src/constants";

import { Flex } from "@src/components/shared-ui-components/Flex";
import {
  AmountWrapper,
  DividerWrapper,
  LabourCogsWrapper,
  PercentageWrapper,
} from "./style";

interface LabourCogsTotalTargetProps {
  title: string;
  amount: number | null;
  percentage: number | null;
  loading: boolean;
  hideTarget?: boolean;
  isInteger?: boolean;
}

const LabourCogsTotalTargetShared = (props: LabourCogsTotalTargetProps) => {
  const { title, amount, percentage, hideTarget, loading, isInteger } = props;

  const getAmount = () => {
    if (loading) return <Skeleton width="70%" />;
    if (amount === null || amount === undefined) return <ErrorState />;
    return (
      <AmountWrapper>
        <TypographyH5>
          {isInteger
            ? formatNumberWithCommaAndDollar(amount, 0, true)
            : formatNumberWithCommaAndDollar(amount)}
        </TypographyH5>
      </AmountWrapper>
    );
  };

  const getPercentage = () => {
    if (loading) return <Skeleton width="70%" />;
    if (percentage === null || percentage === undefined) return <ErrorState />;
    return (
      <PercentageWrapper>
        <TypographyH5 className="percentage-wrapper">
          {formatWithPercentage(percentage, 0, true)}
        </TypographyH5>
      </PercentageWrapper>
    );
  };

  const gridSize = hideTarget ? 12 : 6;

  const getValue = () => {
    return (amount === null || amount === undefined) &&
      (percentage === null || percentage === undefined) ? (
      <Grid xs={12} md={12} item>
        <ErrorState />
      </Grid>
    ) : (
      <Flex flexWrap="wrap" direction="row">
        {getAmount()}
        <DividerWrapper>
          <Divider orientation="vertical" />
        </DividerWrapper>
        <LabourCogsWrapper>{getPercentage()}</LabourCogsWrapper>
      </Flex>
    );
  };

  return (
    <Grid xs={gridSize} md={gridSize} item>
      <Flex direction="column">
        <TypographyH6>{title}</TypographyH6>
        {loading ? <Skeleton width="70%" /> : getValue()}
      </Flex>
    </Grid>
  );
};

LabourCogsTotalTargetShared.defaultProps = {
  hideTarget: false,
  isInteger: false,
};

export default LabourCogsTotalTargetShared;
